import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-content":"center","justify-content":"center"} }

import {ref} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Head',
  props: {
    title: {
        type: String,
        default: undefined,
    },
    titleLeftShow: {
        type: Boolean,
        default: false,
    },
    titleBold: {
        type: Boolean,
        default: true,
    },
    leftShow: {
        type: Boolean,
        default: false,
    },
    rightShow: {
        type: Boolean,
        default: false,
    },
    buttonTitle: {
        type: String,
        default: undefined,
    },
    buttonType: {
        type: String,
        default: undefined
    },
    buttonDisable: {
        type: Boolean,
        default: false
    },
    headHeight: {
        type: Number,
        default: 50,
    },
    bottomBorderShow: {
        type: Boolean,
        default: false,
    },
    iconColor: {
        type: String,
        default: undefined,
    },
},
  emits: [
    "leftIconClick",
    "rightIconClick",
    "mainClick",
    "onButtonClick",
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loading = ref<boolean>(false)

function leftIconClick() {
    emit("leftIconClick");
}

function rightIconClick() {
    emit("rightIconClick");
}

function mainClick() {
    emit("mainClick");
}

function onButtonClick() {
    loading.value = true
    emit("onButtonClick");
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`head ${props.bottomBorderShow ? 'bottomBorder' : ''}`),
    onClick: _withModifiers(mainClick, ["stop"]),
    style: _normalizeStyle(`height: ${__props.headHeight}px;`)
  }, [
    (props.leftShow)
      ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 20,
          class: "left-icon",
          style: _normalizeStyle(`${__props.iconColor ? `color:${__props.iconColor}` : ''}`),
          onClick: _withModifiers(leftIconClick, ["stop"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowLeft)
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(props.titleLeftShow ? 'centerTitle' : ''),
      style: _normalizeStyle(__props.titleBold ? 'font-weight: bold;' : '')
    }, [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "titleLeftIcon"),
        _createTextVNode(" " + _toDisplayString(__props.title), 1)
      ])
    ], 6),
    (__props.buttonTitle)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: __props.buttonType,
          disabled: __props.buttonDisable,
          loading: loading.value,
          class: "right-icon",
          onClick: onButtonClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.buttonTitle), 1)
          ]),
          _: 1
        }, 8, ["type", "disabled", "loading"]))
      : _createCommentVNode("", true),
    (props.rightShow)
      ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 2,
          size: 20,
          class: "right-icon",
          style: _normalizeStyle(`${__props.iconColor ? `color:${__props.iconColor}` : ''}`),
          onClick: _withModifiers(rightIconClick, ["stop"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowRight)
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})